import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import ColorLens from "@mui/icons-material/ColorLens";
import Title from "@mui/icons-material/Title";
import { Badge, Box, Dialog, Tab, Tabs } from "@mui/material";
import { Scrollbar } from "../../components/Scrollbar/index.js";
import { AdvancedThemeSettings } from "./components/AdvancedThemeSettings/AdvancedThemeSettings.js";
import { Palette } from "./components/Palette/Palette.js";
import { ThemeActions } from "./components/ThemeActions/ThemeActions.js";
import { Typography } from "./components/Typography/Typography.js";
import { usePreviewTheme as usePreviewStoredTheme } from "./context/StoredThemes.js";
import { usePreviewTheme } from "./hooks/usePreviewTheme.js";
function ThemePreview(props) {
  const { onClose } = props;
  const {
    tab,
    showAdvancedSettings,
    handleTabChange,
    handleOpenAdvancedSettingsModal,
    handleCloseAdvancedSettingsModal
  } = usePreviewTheme();
  const { previewTheme } = usePreviewStoredTheme();
  const palette = typeof previewTheme?.colorSchemes?.light === "boolean" ? void 0 : previewTheme?.colorSchemes?.light?.palette;
  const paletteModified = Object.keys(palette || {}).length > 0;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Box, { "data-testid": "theme-preview-root", sx: { height: "100%", position: "relative", width: 360 }, children: /* @__PURE__ */ jsxs(
      Box,
      {
        "data-testid": "theme-preview-grid",
        sx: {
          borderRight: "1px solid rgba(0, 0, 0, .125)",
          display: "grid",
          gridTemplateRows: "auto 1fr",
          height: "100%"
        },
        children: [
          /* @__PURE__ */ jsx(ThemeActions, { onClose, onOpenAdvancedSettingsModal: handleOpenAdvancedSettingsModal }),
          /* @__PURE__ */ jsx(Scrollbar, { children: /* @__PURE__ */ jsxs(Box, { sx: { paddingX: 1 }, children: [
            /* @__PURE__ */ jsx(
              Box,
              {
                sx: {
                  borderBottom: 1,
                  borderColor: "divider",
                  marginBottom: 1
                },
                children: /* @__PURE__ */ jsxs(Tabs, { onChange: handleTabChange, value: tab, variant: "fullWidth", children: [
                  /* @__PURE__ */ jsx(
                    Tab,
                    {
                      icon: /* @__PURE__ */ jsx(
                        Badge,
                        {
                          badgeContent: " ",
                          color: "error",
                          invisible: !paletteModified,
                          overlap: "circular",
                          variant: "dot",
                          children: /* @__PURE__ */ jsx(ColorLens, { fontSize: "small" })
                        }
                      ),
                      label: "Palette"
                    }
                  ),
                  /* @__PURE__ */ jsx(Tab, { icon: /* @__PURE__ */ jsx(Title, { fontSize: "small" }), label: "Typography" })
                ] })
              }
            ),
            tab === 0 && /* @__PURE__ */ jsx(Palette, {}),
            tab === 1 && /* @__PURE__ */ jsx(Typography, {})
          ] }) })
        ]
      }
    ) }),
    /* @__PURE__ */ jsx(Dialog, { fullWidth: true, maxWidth: "xl", onClose: handleCloseAdvancedSettingsModal, open: showAdvancedSettings, children: /* @__PURE__ */ jsx(AdvancedThemeSettings, { onClose: handleCloseAdvancedSettingsModal }) })
  ] });
}
export {
  ThemePreview
};
//# sourceMappingURL=ThemePreview.js.map
